import { Component, OnInit, TemplateRef, ChangeDetectorRef, QueryList } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { MasterService } from '../../master/services/master-service';
import { CommonHelper } from '../../../helper/helper.component';
import { CommonConstants } from '../../../shared/constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from '../../../shared/service/data.service'
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  providers: [MasterService, CommonHelper]
})
export class UserComponent implements OnInit {
  modalRef: BsModalRef;
  modalRef1: BsModalRef;
  submitted = false;
  userData: any;
  statesData: any;
  editDataUser: any;
  dataTable: any;
  errorOrResponse = false;
  detailUserForm: any;
  addressLine1: any;
  addressLine2: any;
  addressPinCode: any;
  addressDistricts: any;
  addressStates: any;
  currentAddressLine1: any;
  currentAddressLine2: any;
  currentAddressPinCode: any;
  currentAddressDistricts: any;
  selectedState: string = "";
  currentAddressStates: any;
  changePasswordFormGroup: FormGroup;
  dtElements: QueryList<DataTableDirective>;
  language: any = 'en';
  // showPassword: any;
  passWordData: any;
  showPassword: string = CommonConstants.passwordDefaultValue;
  showPasswordConfirmPassword: string = CommonConstants.passwordDefaultConfirmValue;
  constructor(private modalService: BsModalService, public dataService: DataService, public router: Router, private masterService: MasterService, private chRef: ChangeDetectorRef, private commonHelper: CommonHelper, private spinner: NgxSpinnerService, private fb: FormBuilder
  ) { }


  ngOnInit() {
    // this.getStates();
    this.language = localStorage.getItem('language');
    this.getUsers(this.language);
    this.passwordValidation();
  }
  /**
    * Open modal Popup
    * @param template
    */
  addUserModal() {
    this.dataService.editUser = "addUserDetails";
    this.router.navigate(['/manage-user']);
  }

  // password validation
  passwordValidation() {
    this.changePasswordFormGroup = this.fb.group({
      newUserPassword: ['', [Validators.required, Validators.pattern(CommonConstants.passwordNotAllowSpaceRegex)]],
      confirmPassword: ['', [Validators.required, Validators.pattern(CommonConstants.passwordNotAllowSpaceRegex)]],
    })
  }

  // match the passwords
  passwordsMatch() {

    if (this.changePasswordFormGroup.value.newUserPassword !== this.changePasswordFormGroup.value.confirmPassword) {
      this.commonHelper.toasterMessageError('Passwords do not match');
    }

  }

  // submit password
  submitPasswod() {
    this.submitted = true;
    const data: any = {
      password: this.changePasswordFormGroup.value.newUserPassword,
      confirmPassword: this.changePasswordFormGroup.value.confirmPassword,
      EmailOrMobile: this.passWordData.email
    }

    this.masterService.updatePassword('user/forgot_password', data).subscribe((response: any) => {
      if (response.status == 200) {
        this.commonHelper.toasterMessage(response.message);
        this.spinner.hide();
        this.getUsers(this.language);
        this.modalRef1.hide();
        this.errorOrResponse = true;
        this.changePasswordFormGroup.reset();
      } else {
        this.spinner.hide();
        // this.modalRef1.hide();
        this.changePasswordFormGroup.reset();
        this.errorOrResponse = true;
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
      }
    }, err => {
      this.spinner.hide();
      // this.modalRef1.hide();
      // this.changePasswordFormGroup.reset();
      this.errorOrResponse = true;
    }

    )
  }

  // password close
  closePopup() {
    this.modalRef1.hide();
    this.changePasswordFormGroup.reset();
  }

  /**
* Password show 
* @param value 
*/
  passwordShow(value: string) {
    this.showPassword = value === 'show' ? 'text' : 'password';
  }

  /**
* Confirm Password show 
* @param value 
*/
  confirmPasswordShow(value: string) {
    this.showPasswordConfirmPassword = value === 'show' ? 'text' : 'password';
  }

  get passwordUserF() {
    return this.changePasswordFormGroup.controls
  }

  /*get states*/
  getStates() {
    try {
      this.spinner.show();
      this.errorOrResponse = false;
      this.masterService.getAll('active_states').subscribe((response: any) => {
        if (response.status == 200) {
          this.spinner.hide();
          if (response.data.length != 0) {
            this.statesData = response.data;
            this.errorOrResponse = true;
          } else {
            this.statesData = []
            this.errorOrResponse = true;
          }
        } else {
          this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
          this.statesData = [];
          this.errorOrResponse = true;
          // this.detectTableChanges();
          this.commonHelper.toasterMessageError(CommonConstants.statesMessage);
          this.spinner.hide();
        }
      });

    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
    setTimeout(() => {
      this.spinner.hide();
      if (this.errorOrResponse == false) {
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
      }
    }, 40000)
  }

  languageChange(event: any) {
    this.language = event
  
    if (this.language == 'hn' || this.language == 'en') {
      this.getUsers(this.language);
    }
   
  }


  /*get user list*/
  getUsers(language:any) {
     let url;// = 'en' ? '//cdn.datatables.net/plug-ins/1.10.19/i18n/English.json' : '//cdn.datatables.net/plug-ins/1.10.19/i18n/Hindi.json';
    if (language == 'en') {
       url = '//cdn.datatables.net/plug-ins/1.10.19/i18n/English.json';
    }else{
       url = '//cdn.datatables.net/plug-ins/1.10.19/i18n/Hindi.json';
    }
    try {
      this.spinner.show();
      this.errorOrResponse = false;
      this.masterService.getAll('user').subscribe((response: any) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.userData = response.data;
            this.reploatingDataTable();
            this.chRef.detectChanges();
            const table: any = $('table');
            if (language == 'en') {
              this.dataTable = table.DataTable(
                {
                  language: {
                    "emptyTable": "No data available in table",
                    "info": "Showing _START_ to _END_ of _TOTAL_ entries",
                    "infoEmpty": "Showing 0 to 0 of 0 entries",
                    "infoFiltered": "(filtered from _MAX_ total entries)",
                    "lengthMenu": "Show _MENU_ entries",
                    "loadingRecords": "Loading...",
                    "processing": "Processing...",
                    "search": "Search:",
                    "zeroRecords": "No matching records found",
                    "paginate": {
                      "first": "First",
                      "last": "Last",
                      "next": "Next",
                      "previous": "Previous"
                    },
                    "aria": {
                      "sortAscending": ": activate to sort column ascending",
                      "sortDescending": ": activate to sort column descending"
                    }
                  }
                }
              ).draw();
            } else {
              this.dataTable = table.DataTable(
                {
                  language: {
                    "emptyTable": "तालिका में कोई डेटा उपलब्ध नहीं है",
                    "info": "कुल _TOTAL_ एंट्रीज़ में से _START_ से _END_ तक दिखा रहे हैं",
                    "infoEmpty": "कुल 0 एंट्रीज़ में से 0 से 0 तक दिखा रहे हैं",
                    "infoFiltered": "(_MAX_ एंट्रीज़ से फ़िल्टर किए गए)",
                    "lengthMenu": "_MENU_ एंट्रीज़ दिखाएं",
                    "loadingRecords": "लोड हो रहा है...",
                    "processing": "प्रसंस्करण...",
                    "search": "खोजें:",
                    "zeroRecords": "कोई मिलान नहीं मिला",
                    "paginate": {
                      "first": "पहला",
                      "last": "अंतिम",
                      "next": "अगला",
                      "previous": "पिछला"
                    },
                    "aria": {
                      "sortAscending": ": आरोही क्रम में कॉलम को क्रमित करने के लिए सक्रिय करें",
                      "sortDescending": ": अवरोही क्रम में कॉलम को क्रमित करने के लिए सक्रिय करें"
                    }
                  }
                })
            }
           
            this.errorOrResponse = true;
          } else {
            this.userData = [];
            this.reploatingDataTable();
            this.errorOrResponse = true;
            this.chRef.detectChanges();
            const table: any = $('table');
            this.dataTable = table.DataTable().draw();
            this.spinner.hide();
            this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
          }
          // }
          // else {
          //   this.userData = [];
          //   this.reploatingDataTable();
          //   this.chRef.detectChanges();
          //   const table: any = $('table');
          //   this.dataTable = table.DataTable().draw();
          //   this.spinner.hide();
          //   this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
          // }
        } else {
          this.spinner.hide();
          this.errorOrResponse = true;
        }
      });
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
    setTimeout(() => {
      this.spinner.hide();
      if (this.errorOrResponse == false) {
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
      }
    }, 40000)
  }

  /*validation rules*/
  editUserModal(formData: any, template: TemplateRef<any>) {
    this.dataService.editUser = "editUserDetails";
    this.dataService.getUserDetails(formData);
    this.router.navigate(['/manage-user'])
  }


  /**
  * updating the status of the district
  * @param districtvalues 
  */
  userStatus(uservalues: any) {
    try {
      this.spinner.show();
      this.errorOrResponse = false;
      let status = uservalues.status === 'active' ? "inactive" : "active",
        data = {
          "status": status
        }
      this.masterService.putData('update_user_status/', uservalues.id, data).subscribe((response: any) => {
        if (response) {
          this.spinner.hide();
          this.commonHelper.toasterMessage(response.message);
          this.getUsers(this.language);
          this.errorOrResponse = true;
        } else {
          this.spinner.hide();
          this.errorOrResponse = true;
          this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
        }
      });
    } catch (exc) {
      this.spinner.hide();
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
    setTimeout(() => {
      this.spinner.hide();
      if (this.errorOrResponse == false) {
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
      }
    }, 40000)
  }
  userDescriptionModal(template: TemplateRef<any>, formData) {
    this.addressLine1 = "";
    this.addressLine2 = "";
    this.addressPinCode = "";
    this.addressDistricts = "";
    this.addressStates = "";
    this.currentAddressLine1 = "";
    this.currentAddressLine2 = "";
    this.currentAddressPinCode = "";
    this.currentAddressDistricts = "";
    this.currentAddressStates = "";
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'modal-lg' }));
    // formData.addresses.forEach(element => {
    //   if (element.type == "permanent") {
    //     this.addressLine1 = element.addressLine1;
    //     this.addressLine2 = element.addressLine2;
    //     this.addressPinCode = element.pinCode;
    //     this.addressDistricts = element.districts;
    //     this.addressStates = element.states;
    //   }
    //   if (element.type == "current") {
    //     this.currentAddressLine1 = element.addressLine1;
    //     this.currentAddressLine2 = element.addressLine1;
    //     this.currentAddressPinCode = element.pinCode;
    //     this.currentAddressDistricts = element.districts;
    //     this.currentAddressStates = element.states;
    //   }
    // });
    this.detailUserForm = formData;

  }
  /*redraw the datatable*/
  reploatingDataTable() {
    let table = $('#dataTable1').DataTable();
    table.destroy();
  }

  onStateChange(event: any, filter: string) {

  }

  passworChengeModal(changePasswordModal: TemplateRef<any>, formData) {
    this.modalRef1 = this.modalService.show(changePasswordModal);

    this.passWordData = formData;
  }

  // userPasswordModal(changePasswordModal: TemplateRef<any>, formData) {

  //   this.modalRef = this.modalService.show(changePasswordModal);


  // }
}
